import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";

// 掛金納付対象職員届データ提供の同意日更新API
import {
  IAPI_PRE009_Request,
  IAPI_PRE009_Response,
} from "../../../type/apiType";

// 掛金納付対象職員届データ提供の同意日更新API
// API仕様書_掛金
const httpAPI_PRE009 = async (
  param: IAPI_PRE009_Request
): Promise<IAPI_PRE009_Response> => {
  let res = await http.post(ApiUrl.API_PRE009, {
    ...param,
  });

  return res.data;
};

export { httpAPI_PRE009 };
